import React, { useEffect, useState } from 'react'
import SearchBar from './SearchBar'
import youtube from '../apis/youtube'
import VideoList from './VideoList'
import VideoDetail from './VideoDetail'

const App = () => {
    const [videos, setVideos] = useState([])
    const [selectedVideo, setSelectedVideo] = useState(null)


    useEffect(() => {
        onTermSubmit('football')
    }, [])

    const onTermSubmit = async term => {
        const response = await youtube.get('/search', {
            params: {
                q: term,
            }
        })
        setVideos(response.data.items)
        setSelectedVideo(response.data.items[0])
    }
    return (
        <div className='ui container'>
            <h1>Bekoo.Me Youtube Website</h1>
            <SearchBar onFormSubmit={onTermSubmit} />
            <div className='ui grid'>
                <div className="ui row">
                    <div className='ten wide column'>
                        <VideoDetail video={selectedVideo} />
                    </div>
                    <div className='six wide column'>
                        <VideoList
                            videos={videos}
                            onVideoSelect={setSelectedVideo}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}



export default App
